export default __webpack_public_path__ + "static/media/define3.2e65a461.png";